'use client';

import { ElementRef } from 'react';
import type { ComponentProps } from 'react';
import { PanelLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useSidebar } from './context';

export const SidebarTrigger = ({
  ref,
  className,
  onClick,
  ...props
}: ComponentProps<typeof Button> & {
  ref?: React.RefObject<ElementRef<typeof Button> | null>;
}) => {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      ref={ref}
      data-sidebar="trigger"
      variant="ghost"
      size="icon"
      className={cn('h-6 w-6 text-[var(--color-grey-45)]', className)}
      onClick={(event) => {
        onClick?.(event);
        toggleSidebar();
      }}
      {...props}
    >
      <PanelLeft className="h-4 w-4" />
      <span className="sr-only">Toggle Sidebar</span>
    </Button>
  );
};
SidebarTrigger.displayName = 'SidebarTrigger';
